// components/CtaButton.tsx
import * as React from "react";
import Link from "next/link";
import Image from "next/image";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { CircularProgress } from "@mui/material";

const baseSx = {
    textTransform: "none",
    borderRadius: "8px",
    px: 20,
    py: 1,
    fontSize: "15px",
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    gap: "2px",
    boxShadow: "none",
};

const baseSxStart = {
    borderRadius: "8px",
    textTransform: "none",
    pl: 0,
    pr: 1.5,
    py: 1,
    fontSize: 16,
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    gap: "2px",
    boxShadow: "none",
};




export default function ProfileButton({
    cta,
    label: labelProp,
    href: hrefProp,
    endIconNode,
    endIconSrc = null,
    sx,
    onClick,
    iconPosition = "start",
    disableRipple = true,
    arrowWidth = 15,
    size,
    loader,
    variant = "primary", // "primary" = teal, "secondary" = gray
    ...rest
}) {
    const label = labelProp ?? cta?.label ?? "Submit";
    const href = hrefProp ?? cta?.href;
    const clickHandler = onClick ?? cta?.onClick;

    // style presets
    const variantStyles =
        variant === "primary"
            ? {
                background: "linear-gradient(180deg, #7fd0cb 0%, #0f7f8a 100%)",
                color: "#fff",
                "&:hover": {
                    background: "linear-gradient(180deg, #75c6c0 0%, #0d707b 100%)",
                },
            }
            : {
                background: "#d1d5db",
                color: "#fff",
                "&:hover": { background: "#c4c4c4" },
            };


    const roundIconSx = {
        ml: 0.5,
        width: size === "small" ? 24 : 30,
        height: size === "small" ? 24 : 30,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
    };

    const EndIcon =
        endIconSrc
            ? (
                <Box sx={roundIconSx}>
                    <Image
                        src={endIconSrc}
                        alt=""
                        width={arrowWidth}
                        height={arrowWidth}
                        style={{
                            filter: variant === "secondary" ? "invert(0.4)" : "none",
                        }}
                    />
                </Box>
            )
            : null;


    const commonProps = {
        disableRipple,
        sx: [iconPosition === "start" ? baseSxStart : baseSx, variantStyles, sx],
        onClick: clickHandler,
        ...rest,
    };

    if (href) {
        return iconPosition === "start" ? (
            <Button component={Link} href={href} {...commonProps}>
                {EndIcon}
                {label}
            </Button>
        ) : (
            <Button component={Link} href={href} {...commonProps}>
                {label}
                {EndIcon}
            </Button>
        );
    }

    return iconPosition === "start" ? (
        <Button {...commonProps}>
            {EndIcon}
            {label}
        </Button>
    ) : (
        <Button {...commonProps}>
            {label}
            {EndIcon}
        </Button>
    );
}
